<template>
  <div>
    <vs-popup :title="$t(popupTitle)" :active.sync="showModal">
      <form>
        <div class="flex gap-2">
          <div class="w-1/2">
            <label class="vs-select--label">{{ $t("Account") }}</label>
            <v-select
              label="name"
              :options="listOfAccount"
              name="account"
              v-model="account"
              @input="onlistOfAccountSelected"
              :clearable="false"
              dir="rtl"
            >
            </v-select>
            <span class="text-danger text-sm" v-show="errors.has('account')">{{
              errors.first("account")
            }}</span>
          </div>
          <div class="w-1/2">
            <label class="vs-select--label">{{ $t("AccountFloating") }}</label>
            <v-select
              label="name"
              :options="listOfFloatingAccount"
              name="floatingAccount"
              v-model="floatingAccount"
              :loading="searchFlag"
              :clearable="false"
              dir="rtl"
            >
            </v-select>
          </div>
          <vs-button
            class="btn-drop vs-component vs-button bg_l_green bg-danger mt-6 mr-5"
            color="success"
            icon="add"
            :disabled="(( listOfFloatingAccount.length>0 && !floatingAccount) || !account) || searchFlag"
            @click.prevent="AddAccounts(floatingAccount , account)"
          ></vs-button>
        </div>
        <div>
          <table
            v-if="accountsId && accountsId.length > 0"
            class="basic-tbl mt-5"
            id="colored-table-crdit-page"
          >
            <thead>
              <tr>
                <th style="width: 10%">{{ $t("Account") }}</th>
                <th style="width: 10%">{{ $t("AccountCode") }}</th>
                <th style="width: 10%">{{ $t("AccountFloating") }}</th>
                <th style="width: 10%">{{ $t("AccountFloatingCode") }}</th>
                <th style="width: 10%">{{ $t("Action") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="account in accountsId">
                <td style="width: 10%">
                  {{ account.parentName }}
                </td>
                <td style="width: 10%">
                  {{ account.parentCode }}
                </td>
                <td style="width: 10%">
                  <span >
                    {{ account.name ? account.name : "" }}
                  </span>
                </td>
                <td style="width: 10%">
                  <span >
                    {{ account.code ? account.code : "" }}
                  </span>
                </td>
                <td style="width: 10%">
                  <vs-button
                    radius
                    color="danger"
                    size="small"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-x"
                    @click.prevent="deleteAccount(i)"
                    class="d-inline remove-btn flex-shrink-0"
                  ></vs-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <vs-button
          type="filled"
          class="float-right mb-4 mt-12"
          @click.prevent="submitForm"
          :disabled="accountsId && accountsId.length == 0"
          >{{ $t("Save") }}</vs-button
        >
      </form>
    </vs-popup>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Validator } from "vee-validate";
import vSelect from "@/components/CustomVSelect.vue";

const dict = {
  custom: {
    AccountFloatingTitle: {
      required: "لطفا عنوان حساب شناوری را وارد نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  components: {
    "v-select": vSelect,
  },
  props: {
    show: { default: false },
    model: {
      default: {},
    },
  },
  data() {
    return {
      listOfAccount: [],
      listOfFloatingAccount: [],
      accountsId: [],
      command: {
        floatingAccount:null
      },
      modalFlag:false,
      pettycashId:null,
      account:null,
      floatingAccount:null,
      searchFlag:false,
      popupTitle: "",
      disabled: false,
      gridDataSource: {
        type: "app",
        // service: this.model.accountInfo,
      },
    };
  },

  computed: {
    showModal: {
      get: function () {
        this.listOfAccount = [];
        this.listOfFloatingAccount = [];
        this.accountsId = [];
        this.pettycashId=this.model.id;
        this.getData()
        return this.show;
      },
      set: function () {
        this.$emit("close");
        this.account=null;
        this.floatingAccount=null;
      },
    },
  },
  methods: {
    ...mapActions({
      createAccount: "pettyCash/create",
      fetchAccounts: "pettyCash/fetchAllSubsideryAndDetailsAccount",
      fetchPettyCashAccountInfo: "pettyCash/fetchPettyCashAccountInfo",
      fetchFloatingAccounts: "pettyCash/getAllLastLevelOfFloatingAccounts",
    }),
    getData() {
      console.log(this.modalFlag)
      if (this.model.id != null && this.modalFlag) {
        this.fetchAccounts().then((result) => {
        result.forEach((element) => {
          var x = {
            id: element.id,
            name: element.title,
            code: element.code,
          };
          this.listOfAccount.push(x);
        });
      });
        this.fetchPettyCashAccountInfo(this.pettycashId).then((result) => {
        this.accountsId=result
      });
      }

    },

    onlistOfAccountSelected() {
      this.searchFlag=true;
      this.listOfFloatingAccount=[]

      if(this.floatingAccount){
        this.floatingAccount=null

      }
      this.fetchFloatingAccounts(this.account.id).then((result) => {
        this.searchFlag=false;

        result.forEach((element) => {
          var x = {
            id: element.id,
            name: element.title,
            code: element.code,
          };
          this.listOfFloatingAccount.push(x);

        });
      });
    },

    AddAccounts(floatingAccount,account) {
      var duplicateCondition = this.accountsId.findIndex(
        (x) => x.id == account.id
      );
      if (duplicateCondition === -1) {
        this.accountsId.push({
          id: floatingAccount?floatingAccount.id:null,
          name: floatingAccount?floatingAccount.name:null,
          code:floatingAccount?floatingAccount.code:null,
          parentId: account.id,
          parentName: account.name,
          parentCode: account.code,
        });
      } else {
        this.$swal({
          position: "center-center",
          type: "warning",
          text: "حساب موردنظر تکراری است!",
          showConfirmButton: false,
          timer: 2000,
        });
      }
      this.account=null;
      this.floatingAccount=null;
    },
    deleteAccount(index) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.accountsId.splice(index, 1);
        }
      });
    },
    submitForm() {
      if (this.model.id != null) {
        var payload = {
          id: this.model.id,
          accountInfos: this.accountsId,
        };
        this.createAccount(payload).then(() => {
          this.$swal({
            position: "center-center",
            type: "success",
            text: "رکورد مورد‌نظر با موفقیت ویرایش شد!",
            showConfirmButton: false,
            timer: 2000,
          });
          this.$emit("finish");
          this.model = {};
          this.account = null;
          this.$validator.reset();
          this.disabled = false;
        });
      }
    },
  },
  watch: {
    show() {
      if (this.show == true) {
        this.disabled = false;
        this.modalFlag=true;
        this.popupTitle = "AccountCreate";
      }
      else{
        this.modalFlag=false;

      }
      this.$validator.reset();
    },
  },
};
</script>
